import React, {useState} from 'react';
import COLORS from "../../Helpers/utils";

interface CustomButtonProps {
    title: string;
    metadata: string[];
    onClick: () => void;
    imagePath?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    isHovered?: boolean;
}

const BuildingCustomButton: React.FC<CustomButtonProps> = ({
                                                               title,
                                                               metadata,
                                                               onClick,
                                                               imagePath,
                                                               onMouseEnter,
                                                               onMouseLeave,
                                                               isHovered
}) => {
    const [hoverState, setHoverState] = useState(isHovered)

    return (
        <button
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                maxWidth: '400px',
                padding: '10px',
                borderRadius: '10px',
                border: 'none',
                backgroundColor: (isHovered || hoverState) ? '#ffffff' : COLORS.lightGrey,
                textAlign: 'left',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                marginBottom: '15px',
                boxShadow: (isHovered || hoverState) ? '0 0 10px rgba(0, 0, 0, 0.2)' : 'none',
            }}
            onMouseOver={(e) => (setHoverState(true))}
            onMouseOut={(e) => (setHoverState(false))}
            onClick={onClick}
        >
            {imagePath && (
                <img
                    src={`/Images/${imagePath}`}
                    alt={title}
                    style={{
                        width: '40px',
                        height: '40px',
                        objectFit: 'cover',
                        borderRadius: '5px',
                        margin: '5px',
                    }}
                />
            )}

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
                <strong style={{ fontSize: '14px', marginBottom: '5px' }}>{title}</strong>
                <span style={{ fontSize: '12px', color: '#777' }}>{Object.values(metadata).map((text, index) => (
                    <React.Fragment key={index}>
                        {text}<br/>
                    </React.Fragment>
                ))}
                </span>
            </div>
        </button>
    );
};

export default BuildingCustomButton;
